package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordSignSymptomCharacteristicState

@Serializable
open class MedicalRecordSignSymptomCharacteristic(var id: String? = null){
	var medicalRecordSignSymptomId: String? = null
	var signSymptomCharacteristicId: String? = null
	var state: MedicalRecordSignSymptomCharacteristicState? = null
	var isDeleted: Boolean? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as MedicalRecordSignSymptomCharacteristic
		if (id != other.id) return false
		if (medicalRecordSignSymptomId != other.medicalRecordSignSymptomId) return false
		if (signSymptomCharacteristicId != other.signSymptomCharacteristicId) return false
		if (state != other.state) return false
		if (isDeleted != other.isDeleted) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (medicalRecordSignSymptomId?.hashCode() ?: 0)
		result = 31 * result + (signSymptomCharacteristicId?.hashCode() ?: 0)
		result = 31 * result + (state?.hashCode() ?: 0)
		result = 31 * result + (isDeleted?.hashCode() ?: 0)
		return result
	}

}
